import * as Yup from 'yup';

export const MAX_EVIDENCE_LENGTH = 10000;
export const MAX_EVIDENCE_FILES = 10;

export interface EvidenceValues {
  text: string;
  files: File[];
}

export const EvidenceSchema = Yup.object({
  text: Yup.string().trim().required('Enter the evidence.').max(MAX_EVIDENCE_LENGTH),
  files: Yup.array().max(MAX_EVIDENCE_FILES, `Attach at most ${MAX_EVIDENCE_FILES} files.`),
});

export const withFiles = (current: File[], picked: File[]): File[] => {
  const names = new Set(picked.map((file) => file.name));
  return [...current.filter((file) => !names.has(file.name)), ...picked];
};
